import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';

const RESOURCE = '/subscriptions/service-plan/:servicePlanId/service-plan-terms/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    servicePlanId: string;
}

const queryFn = ({ servicePlanId, ...params }: DTO): Promise<ListResponseAPI<ServicePlanTerm>> => {
    return axios.get(formatResourcePath(RESOURCE, { servicePlanId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SERVICE_PLAN_TERMS_RESOURCE, useQueryHook as useListServicePlanTerms };
